/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

$(function(){
  if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {

  var header = $('#top'), d_scroll = $(document).scrollTop();
  var headerH = header.height();
  if(d_scroll >= headerH){
    $('body').addClass('is-scrolled')
  }else{
    $('body').removeClass('is-scrolled')
  }  

  
  $(window).on("scroll", function(){
  	var header = $('#top'), d_scroll = $(document).scrollTop();
    var headerH = header.height();
    console.log("----------")
  	
    if(d_scroll >= headerH){
    	$('body').addClass('is-scrolled')
    }else{
    	$('body').removeClass('is-scrolled')
    }
  })
  }

})


// Insert any custom theme js here...